import { render } from "./AsignarComplementos.vue?vue&type=template&id=4c7a69cc&scoped=true"
import script from "./AsignarComplementos.vue?vue&type=script&lang=js"
export * from "./AsignarComplementos.vue?vue&type=script&lang=js"

import "./AsignarComplementos.vue?vue&type=style&index=0&id=4c7a69cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7a69cc"]])

export default __exports__